import * as React from 'react';

import Button from '../../base/buttons/Button';
import Card from '../../base/Card';

interface ICalloutDismissConfirmationProps {
  /**
   * The severity of the card (error or warning)
   */
  severity: 'error' | 'warning';
  /**
   * Optional className to apply to the card
   */
  className?: string;
  /**
   * Called when the user confirms or denies that the callout was helpful.
   * @param appropriate - true if helpful, false if not helpful
   */
  onConfirm: (appropriate: boolean) => void;
  /**
   * Optional header icon to display
   */
  headerIcon?: React.ReactNode;
  /**
   * Optional header label to display
   */
  headerLabel?: string;
  /**
   * The question text to display in the body
   * @default 'Did flagging this spending help you?'
   */
  question?: string;
}

const CalloutDismissConfirmation = ({
  severity,
  className,
  onConfirm,
  headerIcon,
  headerLabel,
  question = 'Did flagging this spending help you?',
}: ICalloutDismissConfirmationProps) => {
  return (
    <Card severity={severity} className={className}>
      {headerIcon && headerLabel && <Card.Header icon={headerIcon} label={headerLabel} />}
      <Card.Body className="items-center justify-center gap-3 pt-3">
        <p className="text-secondary text-sm font-medium leading-5">{question}</p>
        <div className="flex w-full items-center justify-center gap-2">
          <Button className="w-full max-w-32" size="xs" color="secondary-destructive" onClick={() => onConfirm(false)}>
            No
          </Button>
          <Button className="w-full max-w-32" size="xs" color="primary-success" onClick={() => onConfirm(true)}>
            Yes
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
};

export default CalloutDismissConfirmation;
